// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1579618889637
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/views/Transactions/Transactions.scss
// module id = ./src/views/Transactions/Transactions.scss
// module chunks = 0